import { isoToYyyyMmDd } from "./date-helpers";

function initialWLMFormValues(initialValues, userProfile) {
  const {
    usStandardSize = userProfile?.usStandardSize || "",
    heightInches = userProfile?.height || "",
    bustSize = userProfile?.bustSize || "",
    birthday = isoToYyyyMmDd(userProfile?.dateOfBirth) || "",
  } = initialValues || {};

  return {
    usStandardSize,
    heightInches,
    bustSize,
    birthday,
  };
}

const generateText = (inputArr, labelJson, threshold = 6) => {
  let showText = inputArr?.length > 0 ? inputArr.map(eachItem => labelJson[eachItem]).join(", ") : "Select Size";
  if (showText.length > threshold && showText !== "Select Size") {
    showText = showText.slice(0, threshold) + "...";
  }
  return showText;
};

const convertArrayToObject = (keyName, arr) => {
  if (!Array.isArray(arr)) {
    return null;
  }
  const newObj = {};
  arr.forEach(element => {
    if (element?.[keyName]) {
      newObj[element?.[keyName]] = { ...element };
    }
  });
  return newObj;
};

export { initialWLMFormValues, generateText, convertArrayToObject };
